'use strict';

var _ = require('lodash');
var togglePrefClassYear = require('./togglePrefClassYear.js');
var toggleChildFields = require('./toggleChildFields.js');
var toggleLifeThreatening = require('./toggleDietaryPrefs.js');
var validate_textfield = require('../common/validate-textfield');
var validate_select = require('../common/validate-select');
var validate_cb_1ormore = require('../common/validate-checkables-atleastone.js');
var membValidation = require('./validateMemberNumber');
var validatePhoneNumber = require('../common/validate-phonenumber');

module.exports = {
	findById: function (id) {
		return _.find(window.iq.partyMembers, 'regInProgressPersonId', id);
	},
	toggleFF: function doToggleFF() {
		var saving = window.jQuery('#saveFreqFlyer').is(':checked');
		var isMinor = window.jQuery('#party-container input[name=isMinor][data-minor=true]').is(':checked') === true;
		var box = window.jQuery('#email2').closest('.expandable');
		if (saving && !isMinor) {
			box.addClass('active');
		} else {
			box.removeClass('active');
		}
	},
	editPartyMember: function (id) {
		window.jQuery('#party-container .error').removeClass('error');
		var partyMember = this.findById(id);
		var personTypes = populateTypeArray(partyMember.personTypeId);
		var relationTypes = populateTypeArray(partyMember.relationTypeId);
		var dietaryNeeds = populateTypeArray(partyMember.dietaryPreferenceIds);

		toggleTypes('personType', personTypes);
		toggleTypes('relationType', relationTypes);
		toggleTypes('dietaryNeeds', dietaryNeeds);

		if (partyMember.isPrimary === 1 || partyMember.isMinor === 0) {
			window.jQuery('input[data-minor=false]').prop('checked', 'checked');
		} else {
			window.jQuery('input[data-minor=true]').prop('checked', 'checked');
		}

		togglePrefClassYear();
		toggleChildFields('#party-container');

		if (window.jQuery('input[data-minor=true]').is(':checked')) {
			window.jQuery('#age').val(partyMember.age);
		}

		window.jQuery('#prefix').val(partyMember.salutation);
		window.jQuery('#name_suffix').val(partyMember.suffix);
		window.jQuery('#firstName').val(partyMember.firstName);
		window.jQuery('#lastName').val(partyMember.lastName);
		window.jQuery('#maidenName').val(partyMember.maidenName);
		window.jQuery('#badgeName').val(partyMember.badgeName);
		window.jQuery('#email').val(partyMember.emailAddress);
		window.jQuery('#email2').val(partyMember.emailAddress);
		window.jQuery('#preferredClassYear').val(partyMember.preferredClassYear);
		window.jQuery('#phoneNumber').val(partyMember.phoneNumber);
		window.jQuery('#phoneNumberType').val(partyMember.phoneNumberType);
		window.jQuery('#personId').val(partyMember.regInProgressPersonId);
		window.jQuery('#isPrimary').val(partyMember.isPrimary);
		window.jQuery('#registrationId').val(partyMember.registrationId);
		window.jQuery('#lifeThreatening').val(partyMember.lifeThreatening);
		window.jQuery('#mobilityNeeds').val(partyMember.mobilityNeeds);
		if (partyMember.isPrimary === 1) {
			window.jQuery('.hideIfPrimary').hide();
		} else {
			window.jQuery('.hideIfPrimary').show();
		}
		toggleOptIn('smsOptIn', partyMember.smsOptIn);
		toggleOptIn('consentToList', partyMember.consentToList);
		toggleOptIn('saveFreqFlyer', partyMember.isFrequentFlyer);
		toggleLifeThreatening();
		this.toggleFF();

		window.jQuery('input[name=dietaryNeeds]').click(function () {
			toggleLifeThreatening();
		});

		/* HELPERS */

		function toggleTypes(name, typeArray) {
			window.jQuery('input[name=' + name + ']:checked').prop('checked', false);
			_.each(typeArray, function (typ) {
				window.jQuery('input[name=' + name + '][value=' + typ + ']').prop('checked', true);
			});
		}
		function populateTypeArray(typeId) {
			if (typeof typeId === 'number') {
				return [typeId];
			} else if (typeId !== null && typeId !== undefined) {
				return typeId.split(',');
			}
		}
		function toggleOptIn(flagName, flagValue) {
			if (flagValue === 1 || flagValue === true) {
				window.jQuery('input[name=' + flagName + ']').prop('checked', true);
			} else {
				window.jQuery('input[name=' + flagName + ']').prop('checked', false);
			}
		}
	},
	validateMemberNumber: membValidation.validateMemberNumber,
	validate: function () {
		// var reEnableSubmit = window.jQuery( '#party-container' ).data( 'reenable' );
		var error = areThereErrors();

		if (error) {
			window
				.jQuery('.error')
				.on('click keyup', '.personType,.relationType,.isRequired,#saveFreqFlyer,#preferredClassYear,#email2,#phoneNumber', function () {
					//wrap this call in a function that swallows the return value so that it won't prevent a checkbox click from being set
					areThereErrors();
				});
			window.alert('Please make a selection in all fields marked in red');
			window.jQuery('#party-container').data('reenable');
		}
		return !error;
	}
};

function areThereErrors() {
	var error = false;
	error = validate_cb_1ormore('#party-container .personType') || error;
	error = validate_cb_1ormore('#party-container .relationType') || error;
	error = validate_textfield('#party-container .isRequired') || error;
	error = validatePhoneNumber('#party-container #phoneNumber') || error;

	error = !membValidation.isMemberNumberValid() || error;

	error = validate_select('#preferredClassYear', '') || error;

	if (window.jQuery('input[data-minor=true]').is(':checked')) {
		var age = window.jQuery('#age').val();
		if (isNaN(age)) {
			error = true;
			window.jQuery('#age').closest('.errorContainer').addClass('error');
		} else if (age < 0 || age > window.iq.ageOfMajority) {
			error = true;
			window.jQuery('#age').closest('.errorContainer').addClass('error');
		}
	}

	if (
		window.jQuery('#saveFreqFlyer').is(':checked') &&
		!window.jQuery('.relationType[data-child=true]').is(':checked')
	) {
		error = validate_textfield('#email2') || error;
	}

	//scroll the first error into view! 💪
	window.jQuery('.errorContainer.error')[0].scrollIntoView();

	return error;
}
